import React from "react"
import Relay from "react-relay"
import ImageView from "./ImageView"
import AudioPlayer from "../elements/AudioPlayer"
import {
  getAudioFromResource,
  getAudioFromFile,
  getFileByType
} from "../../scripts/resource"
import MediaMissing from "./MediaMissing"
import { injectIntl, FormattedMessage } from "react-intl"

import { default as audioMessages } from "../../messages/audio"

class AudioView extends React.Component {
  render() {
    const { resource, file } = this.props
    const smallForm = this.props.smallForm || false
    const audio = file ? getAudioFromFile(file) : getAudioFromResource(resource)
    const audioSrc = audio && audio.url

    return (
      <div>
        <ImageView
          resource={resource}
          file={file}
          withDeepZoom={false}
          withSchemaUrl={false}
          imgClassName="state-canvas-cover"
        />

        {audioSrc && (
          <span className="hide for-schema-markup-only" itemProp="url">
            {audioSrc}
          </span>
        )}

        {audioSrc && (
          <AudioPlayer
            peaksURL={this._getAudioPeaksURL()}
            src={audioSrc}
            smallForm={smallForm}
            className="c-mviewer__audio"
          >
            <audio style={{ display: "none" }} controls>
              <source src={audioSrc} type={audio.mime_type} />
              <FormattedMessage {...audioMessages.browser} />
            </audio>
          </AudioPlayer>
        )}

        {!audioSrc && <MediaMissing resource={resource} file={file} />}
      </div>
    )
  }

  _getAudioPeaksURL = () => {
    const { file } = this.props

    const audioFile = file
      ? file
      : getFileByType(this.props.resource.files, "audio")

    return (
      audioFile &&
      audioFile.audio &&
      audioFile.audio.waveform_json &&
      audioFile.audio.waveform_json.url
    )
  }
}

export default Relay.createContainer(AudioView, {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
      type
      files {
        type
        audio {
          lossy {
            url
            mime_type
          }
          waveform_json {
              url
          }
        }
      }
      ${ImageView.getFragment("resource")}
      ${MediaMissing.getFragment("resource")}
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/AudioView.js